/**
 * FBA 费率配置统一导出
 */

import { US_CONFIG as US_CONFIG_2026 } from './us';
import { US_CONFIG_2025 } from './us-2025';
import { UK_CONFIG, DE_CONFIG, FR_CONFIG, IT_CONFIG, ES_CONFIG } from './europe';
import { JP_CONFIG, CA_CONFIG } from './other';
import type { Site, SiteConfig } from '../types';

/**
 * 根据日期自动选择美国站费率版本
 * 2025年1月16日 - 2026年1月14日: 使用2025费率
 * 2026年1月15日起: 使用2026费率
 */
const getUSConfig = (date: Date = new Date()): SiteConfig => {
    const cutoffDate = new Date('2026-01-15');
    return date >= cutoffDate ? US_CONFIG_2026 : US_CONFIG_2025;
};

export const FBA_DATA: Record<Site, SiteConfig> = {
    US: getUSConfig(),
    UK: UK_CONFIG,
    DE: DE_CONFIG,
    FR: FR_CONFIG,
    IT: IT_CONFIG,
    ES: ES_CONFIG,
    JP: JP_CONFIG,
    CA: CA_CONFIG
};

/**
 * 获取指定日期的费率配置
 */
export const getFBAConfig = (site: Site, date: Date = new Date()): SiteConfig | null => {
    if (site === 'US') {
        return getUSConfig(date);
    }
    return FBA_DATA[site] || null;
};
